module.exports = __webpack_public_path__ + "img/icon-profitable.b8f73cb0.svg";